function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoInverted = function SvgLogoInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240.27 58.34"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.29 33.78c0 1 .05 2.29 1.45 2.29 1.2 0 1.51-.57 1.51-2.29v-4h5.25v2.75c0 6.35-2.34 8.17-6.76 8.17-3.8 0-6.71-2.08-6.71-8.43V19.9c0-6.35 2.91-8.43 6.71-8.43 4.42 0 6.76 1.82 6.76 8.17v2.23h-5.25v-3.43c0-1.72-.31-2.29-1.51-2.29-1.4 0-1.45 1.25-1.45 2.29ZM75 17.92v22.41h-5.21V2.11H75v12.17c.42-.26 2.44-2.81 4.26-2.81 2.81 0 4 3.23 4 5.57v23.29H78V17.82c0-1.1-.62-1.25-1.24-1.25-1.04 0-1.76 1.35-1.76 1.35Zm19.19 3.85v-3.12c0-1 0-2.6-1.46-2.6-1.77 0-1.45 2.6-1.51 4.21H86v-1.2a7.3 7.3 0 0 1 7.07-7.59 6.4 6.4 0 0 1 6.4 6.45v17.47a26.83 26.83 0 0 0 .36 4.94H94.7a4.38 4.38 0 0 1-.47-2.33h-.37a5.16 5.16 0 0 1-4.21 2.71c-1.4 0-4.21-1-4.21-7 0-9.6 8.27-10.23 8.79-11.94ZM92 35.6a2 2 0 0 0 2.19-1.72V26.6c-2.55 1.09-3.64 3.64-3.64 6.35.04.67.19 2.65 1.45 2.65Zm21-18.31a4.66 4.66 0 0 0-4.11.68 3.22 3.22 0 0 0-1.14 2.6v19.76h-5.25V11.89h5.25v3.17a5.14 5.14 0 0 1 5.25-3.59Zm9.67-12.42v7h3.59v4.73h-3.59v14.16c0 1.77 0 4.68 1.67 4.68a12.07 12.07 0 0 0 1.92-.2v5.14a10 10 0 0 1-2.81.37c-6 0-6-6.24-6-9.57V16.62h-2.65v-4.73h2.65v-7Zm19.55 25.27v3.28s0 7.33-6.81 7.33-6.76-7.49-6.76-7.49V19s.05-7.49 6.81-7.49 6.76 7.33 6.76 7.33v8.27h-8.68v6.19s0 2.86 1.92 2.86 1.88-2.86 1.88-2.86v-3.16ZM133.59 23h3.8v-4s.1-2.91-1.88-2.91-1.92 2.91-1.92 2.91Zm22.77-5.67a4.63 4.63 0 0 0-4.1.68 3.21 3.21 0 0 0-1.15 2.6v19.72h-5.25V11.89h5.25v3.17a5.15 5.15 0 0 1 5.25-3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 4.62a23.84 23.84 0 1 0 5.74 33.23A23.85 23.85 0 0 0 37.6 4.62Z",
    style: {
      fill: "#005faa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.53 4.71a23.72 23.72 0 1 0 5.71 33.07 23.72 23.72 0 0 0-5.71-33.07Z",
    style: {
      fill: "#0060ab",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.47 4.81a23.61 23.61 0 1 0 5.68 32.91 23.62 23.62 0 0 0-5.68-32.91Z",
    style: {
      fill: "#0060ab",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 4.9a23.49 23.49 0 1 0 5.66 32.75A23.5 23.5 0 0 0 37.4 4.9Z",
    style: {
      fill: "#0061ab",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.33 5A23.38 23.38 0 1 0 43 37.59 23.39 23.39 0 0 0 37.33 5Z",
    style: {
      fill: "#0061ac",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.27 5.08a23.27 23.27 0 1 0 5.6 32.44 23.27 23.27 0 0 0-5.6-32.44Z",
    style: {
      fill: "#0062ac",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2 5.18a23.15 23.15 0 1 0 5.58 32.28A23.15 23.15 0 0 0 37.2 5.18Z",
    style: {
      fill: "#0062ad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14 5.27a23 23 0 1 0 5.55 32.12 23 23 0 0 0-5.55-32.12Z",
    style: {
      fill: "#0063ad",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.07 5.36a22.93 22.93 0 1 0 5.52 32 22.94 22.94 0 0 0-5.52-32Z",
    style: {
      fill: "#0064ae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 5.45a22.82 22.82 0 1 0 5.5 31.81A22.83 22.83 0 0 0 37 5.45Z",
    style: {
      fill: "#0064ae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.94 5.55a22.7 22.7 0 1 0 5.47 31.65 22.7 22.7 0 0 0-5.47-31.65Z",
    style: {
      fill: "#0065ae",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.88 5.64a22.59 22.59 0 1 0 5.44 31.49 22.6 22.6 0 0 0-5.44-31.49Z",
    style: {
      fill: "#0065af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.81 5.73a22.47 22.47 0 1 0 5.41 31.34 22.5 22.5 0 0 0-5.41-31.34Z",
    style: {
      fill: "#0066af",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 5.82A22.37 22.37 0 1 0 42.13 37a22.37 22.37 0 0 0-5.38-31.18Z",
    style: {
      fill: "#0067b0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68 5.92a22.24 22.24 0 1 0 5.36 31 22.25 22.25 0 0 0-5.36-31Z",
    style: {
      fill: "#0067b0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.62 6A22.14 22.14 0 1 0 42 36.87 22.14 22.14 0 0 0 36.62 6Z",
    style: {
      fill: "#0068b1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.55 6.1a22 22 0 1 0 5.3 30.7 22 22 0 0 0-5.3-30.7Z",
    style: {
      fill: "#0068b1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.49 6.19a21.91 21.91 0 1 0 5.27 30.55 21.93 21.93 0 0 0-5.27-30.55Z",
    style: {
      fill: "#0069b1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.42 6.29a21.79 21.79 0 1 0 5.25 30.38 21.8 21.8 0 0 0-5.25-30.38Z",
    style: {
      fill: "#006ab2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35 6.38a21.68 21.68 0 1 0 5.23 30.23 21.69 21.69 0 0 0-5.23-30.23Z",
    style: {
      fill: "#006ab2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.29 6.47a21.57 21.57 0 1 0 5.19 30.07 21.58 21.58 0 0 0-5.19-30.07Z",
    style: {
      fill: "#006bb3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.22 6.56a21.46 21.46 0 1 0 5.17 29.92 21.46 21.46 0 0 0-5.17-29.92Z",
    style: {
      fill: "#006bb3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.16 6.66a21.34 21.34 0 1 0 5.14 29.75 21.35 21.35 0 0 0-5.14-29.75Z",
    style: {
      fill: "#006cb4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.09 6.75a21.23 21.23 0 1 0 5.12 29.6 21.24 21.24 0 0 0-5.12-29.6Z",
    style: {
      fill: "#006cb4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 6.84a21.12 21.12 0 1 0 5.08 29.44A21.13 21.13 0 0 0 36 6.84Z",
    style: {
      fill: "#006db5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 6.93a21 21 0 1 0 5 29.29 21 21 0 0 0-5-29.29Z",
    style: {
      fill: "#006eb5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9 7a20.89 20.89 0 1 0 5 29.12A20.9 20.9 0 0 0 35.9 7Z",
    style: {
      fill: "#006eb5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.83 7.12a20.77 20.77 0 1 0 5 29 20.77 20.77 0 0 0-5-29Z",
    style: {
      fill: "#006fb6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.77 7.21a20.66 20.66 0 1 0 5 28.81 20.67 20.67 0 0 0-5-28.81Z",
    style: {
      fill: "#006fb6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7 7.3A20.55 20.55 0 1 0 40.65 36 20.56 20.56 0 0 0 35.7 7.3Z",
    style: {
      fill: "#0070b7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.64 7.4a20.43 20.43 0 1 0 4.92 28.49A20.44 20.44 0 0 0 35.64 7.4Z",
    style: {
      fill: "#0071b7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.57 7.49a20.32 20.32 0 1 0 4.9 28.33 20.33 20.33 0 0 0-4.9-28.33Z",
    style: {
      fill: "#0071b7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51 7.58a20.21 20.21 0 1 0 4.86 28.18 20.22 20.22 0 0 0-4.86-28.18Z",
    style: {
      fill: "#0072b8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.44 7.67a20.1 20.1 0 1 0 4.84 28 20.11 20.11 0 0 0-4.84-28Z",
    style: {
      fill: "#0072b8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.37 7.77a20 20 0 1 0 4.82 27.86 20 20 0 0 0-4.82-27.86Z",
    style: {
      fill: "#0073b9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.31 7.86a19.87 19.87 0 1 0 4.79 27.7 19.87 19.87 0 0 0-4.79-27.7Z",
    style: {
      fill: "#0073b9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.24 8A19.76 19.76 0 1 0 40 35.5 19.76 19.76 0 0 0 35.24 8Z",
    style: {
      fill: "#0074ba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.18 8a19.65 19.65 0 1 0 4.73 27.39A19.66 19.66 0 0 0 35.18 8Z",
    style: {
      fill: "#0075ba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.11 8.14a19.53 19.53 0 1 0 4.71 27.23 19.53 19.53 0 0 0-4.71-27.23Z",
    style: {
      fill: "#0075ba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.05 8.23a19.42 19.42 0 1 0 4.67 27.07 19.43 19.43 0 0 0-4.67-27.07Z",
    style: {
      fill: "#0076bb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 8.32a19.3 19.3 0 1 0 4.65 26.91A19.31 19.31 0 0 0 35 8.32Z",
    style: {
      fill: "#0076bb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.92 8.41a19.19 19.19 0 1 0 4.62 26.76 19.2 19.2 0 0 0-4.62-26.76Z",
    style: {
      fill: "#0077bc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.85 8.51a19.07 19.07 0 1 0 4.6 26.59 19.08 19.08 0 0 0-4.6-26.59Z",
    style: {
      fill: "#0078bc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.79 8.6A19 19 0 1 0 39.35 35a19 19 0 0 0-4.56-26.4Z",
    style: {
      fill: "#0078bd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.72 8.69A18.85 18.85 0 1 0 39.26 35a18.85 18.85 0 0 0-4.54-26.31Z",
    style: {
      fill: "#0079bd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.66 8.78a18.74 18.74 0 1 0 4.51 26.13 18.76 18.76 0 0 0-4.51-26.13Z",
    style: {
      fill: "#0079bd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.59 8.88a18.62 18.62 0 1 0 4.49 26 18.63 18.63 0 0 0-4.49-26Z",
    style: {
      fill: "#007abe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.53 9A18.51 18.51 0 1 0 39 34.78 18.53 18.53 0 0 0 34.53 9Z",
    style: {
      fill: "#007abe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.46 9.06a18.4 18.4 0 1 0 4.43 25.65 18.41 18.41 0 0 0-4.43-25.65Z",
    style: {
      fill: "#007bbf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4 9.15a18.29 18.29 0 1 0 4.4 25.5 18.29 18.29 0 0 0-4.4-25.5Z",
    style: {
      fill: "#007cbf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.33 9.25a18.17 18.17 0 1 0 4.38 25.33 18.17 18.17 0 0 0-4.38-25.33Z",
    style: {
      fill: "#007cbf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.26 9.34a18.06 18.06 0 1 0 4.35 25.18 18.07 18.07 0 0 0-4.35-25.18Z",
    style: {
      fill: "#007dc0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2 9.43a17.95 17.95 0 1 0 4.32 25 17.95 17.95 0 0 0-4.32-25Z",
    style: {
      fill: "#007dc0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.13 9.52a17.83 17.83 0 1 0 4.3 24.86 17.84 17.84 0 0 0-4.3-24.86Z",
    style: {
      fill: "#007ec1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.07 9.62a17.72 17.72 0 1 0 4.27 24.7 17.73 17.73 0 0 0-4.27-24.7Z",
    style: {
      fill: "#007fc1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 9.71a17.6 17.6 0 1 0 4.24 24.54A17.6 17.6 0 0 0 34 9.71Z",
    style: {
      fill: "#007fc1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.94 9.8a17.49 17.49 0 1 0 4.21 24.39A17.5 17.5 0 0 0 33.94 9.8Z",
    style: {
      fill: "#0080c2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.87 9.89a17.38 17.38 0 1 0 4.19 24.23 17.39 17.39 0 0 0-4.19-24.23Z",
    style: {
      fill: "#0080c2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.81 10A17.26 17.26 0 1 0 38 34.06 17.27 17.27 0 0 0 33.81 10Z",
    style: {
      fill: "#0081c3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.74 10.08A17.15 17.15 0 1 0 37.87 34a17.15 17.15 0 0 0-4.13-23.92Z",
    style: {
      fill: "#0081c3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.68 10.17a17 17 0 1 0 4.1 23.76 17.06 17.06 0 0 0-4.1-23.76Z",
    style: {
      fill: "#0082c3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.61 10.26a16.93 16.93 0 1 0 4.08 23.6 16.94 16.94 0 0 0-4.08-23.6Z",
    style: {
      fill: "#0083c4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.55 10.36A16.81 16.81 0 1 0 37.6 33.8a16.83 16.83 0 0 0-4.05-23.44Z",
    style: {
      fill: "#0083c4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.48 10.45a16.7 16.7 0 1 0 4 23.28 16.7 16.7 0 0 0-4-23.28Z",
    style: {
      fill: "#0084c5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.42 10.54a16.59 16.59 0 1 0 4 23.13 16.6 16.6 0 0 0-4-23.13Z",
    style: {
      fill: "#0084c5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.35 10.63a16.47 16.47 0 1 0 4 23 16.48 16.48 0 0 0-4-23Z",
    style: {
      fill: "#0085c5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.28 10.73a16.36 16.36 0 1 0 3.94 22.8 16.35 16.35 0 0 0-3.94-22.8Z",
    style: {
      fill: "#0086c6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.22 10.82a16.24 16.24 0 1 0 3.91 22.65 16.25 16.25 0 0 0-3.91-22.65Z",
    style: {
      fill: "#0086c6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.15 10.91A16.13 16.13 0 1 0 37 33.4a16.14 16.14 0 0 0-3.85-22.49Z",
    style: {
      fill: "#0087c7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.09 11A16 16 0 1 0 37 33.34 16 16 0 0 0 33.09 11Z",
    style: {
      fill: "#0087c7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 11.1a15.9 15.9 0 1 0 3.83 22.17A15.9 15.9 0 0 0 33 11.1Z",
    style: {
      fill: "#0088c7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 11.19a15.79 15.79 0 1 0 3.8 22 15.8 15.8 0 0 0-3.8-22Z",
    style: {
      fill: "#0089c8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.89 11.28a15.68 15.68 0 1 0 3.78 21.86 15.68 15.68 0 0 0-3.78-21.86Z",
    style: {
      fill: "#0089c8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.83 11.37a15.57 15.57 0 1 0 3.75 21.71 15.58 15.58 0 0 0-3.75-21.71Z",
    style: {
      fill: "#008ac8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.76 11.47A15.45 15.45 0 1 0 36.48 33a15.46 15.46 0 0 0-3.72-21.53Z",
    style: {
      fill: "#008ac9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7 11.56A15.34 15.34 0 1 0 36.39 33a15.35 15.35 0 0 0-3.69-21.44Z",
    style: {
      fill: "#008bc9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.63 11.65a15.23 15.23 0 1 0 3.67 21.23 15.24 15.24 0 0 0-3.67-21.23Z",
    style: {
      fill: "#008bca",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.57 11.74a15.12 15.12 0 1 0 3.64 21.08 15.13 15.13 0 0 0-3.64-21.08Z",
    style: {
      fill: "#008cca",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 11.84a15 15 0 1 0 3.61 20.91 15 15 0 0 0-3.61-20.91Z",
    style: {
      fill: "#008dca",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.44 11.93A14.89 14.89 0 1 0 36 32.68a14.89 14.89 0 0 0-3.56-20.75Z",
    style: {
      fill: "#008dcb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.37 12a14.77 14.77 0 1 0 3.56 20.6A14.79 14.79 0 0 0 32.37 12Z",
    style: {
      fill: "#008ecb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 12.11a14.66 14.66 0 1 0 3.54 20.44 14.66 14.66 0 0 0-3.54-20.44Z",
    style: {
      fill: "#008ecc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.24 12.21a14.54 14.54 0 1 0 3.5 20.28 14.55 14.55 0 0 0-3.5-20.28Z",
    style: {
      fill: "#008fcc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.17 12.3a14.43 14.43 0 1 0 3.48 20.12 14.43 14.43 0 0 0-3.48-20.12Z",
    style: {
      fill: "#0090cc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.11 12.39a14.32 14.32 0 1 0 3.45 20 14.33 14.33 0 0 0-3.45-20Z",
    style: {
      fill: "#0090cd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.48a14.21 14.21 0 1 0 3.43 19.81A14.21 14.21 0 0 0 32 12.48Z",
    style: {
      fill: "#0091cd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.58a14.09 14.09 0 1 0 3.39 19.65A14.09 14.09 0 0 0 32 12.58Z",
    style: {
      fill: "#0091cd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.91 12.67a14 14 0 1 0 3.37 19.49 14 14 0 0 0-3.37-19.49Z",
    style: {
      fill: "#0092ce",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.85 12.76a13.87 13.87 0 1 0 3.34 19.34 13.88 13.88 0 0 0-3.34-19.34Z",
    style: {
      fill: "#0093ce",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.78 12.85A13.76 13.76 0 1 0 35.1 32a13.76 13.76 0 0 0-3.32-19.15Z",
    style: {
      fill: "#0093ce",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.72 13A13.64 13.64 0 1 0 35 32a13.65 13.65 0 0 0-3.28-19Z",
    style: {
      fill: "#0094cf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.65 13a13.53 13.53 0 1 0 3.26 18.9A13.54 13.54 0 0 0 31.65 13Z",
    style: {
      fill: "#0094cf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.59 13.13a13.42 13.42 0 1 0 3.23 18.7 13.42 13.42 0 0 0-3.23-18.7Z",
    style: {
      fill: "#0095d0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52 13.22a13.3 13.3 0 1 0 3.21 18.55 13.31 13.31 0 0 0-3.21-18.55Z",
    style: {
      fill: "#0096d0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.46 13.32a13.19 13.19 0 1 0 3.17 18.38 13.19 13.19 0 0 0-3.17-18.38Z",
    style: {
      fill: "#0096d0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.39 13.41a13.07 13.07 0 1 0 3.15 18.23 13.08 13.08 0 0 0-3.15-18.23Z",
    style: {
      fill: "#0097d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.33 13.5a13 13 0 1 0 3.12 18.07 13 13 0 0 0-3.12-18.07Z",
    style: {
      fill: "#0097d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.26 13.59a12.85 12.85 0 1 0 3.09 17.92 12.87 12.87 0 0 0-3.09-17.92Z",
    style: {
      fill: "#0098d1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.19 13.69a12.73 12.73 0 1 0 3.07 17.75 12.73 12.73 0 0 0-3.07-17.75Z",
    style: {
      fill: "#0099d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.13 13.78a12.62 12.62 0 1 0 3 17.6 12.63 12.63 0 0 0-3-17.6Z",
    style: {
      fill: "#0099d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.06 13.87a12.51 12.51 0 1 0 3 17.44 12.51 12.51 0 0 0-3-17.44Z",
    style: {
      fill: "#009ad2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 14a12.4 12.4 0 1 0 3 17.29A12.41 12.41 0 0 0 31 14Z",
    style: {
      fill: "#009ad3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.93 14.06a12.28 12.28 0 1 0 3 17.12 12.28 12.28 0 0 0-3-17.12Z",
    style: {
      fill: "#009bd3",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87 14.15a12.17 12.17 0 1 0 2.93 17 12.17 12.17 0 0 0-2.93-17Z",
    style: {
      fill: "#009bd4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 14.24a12.06 12.06 0 1 0 2.91 16.81 12.06 12.06 0 0 0-2.91-16.81Z",
    style: {
      fill: "#009cd4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.74 14.33A11.95 11.95 0 1 0 33.61 31a12 12 0 0 0-2.87-16.67Z",
    style: {
      fill: "#009dd4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.67 14.43a11.82 11.82 0 1 0 2.85 16.49 11.82 11.82 0 0 0-2.85-16.49Z",
    style: {
      fill: "#009dd5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61 14.52a11.72 11.72 0 1 0 2.82 16.33 11.72 11.72 0 0 0-2.82-16.33Z",
    style: {
      fill: "#009ed5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.54 14.61a11.6 11.6 0 1 0 2.8 16.18 11.61 11.61 0 0 0-2.8-16.18Z",
    style: {
      fill: "#009ed5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.48 14.7a11.49 11.49 0 1 0 2.76 16 11.49 11.49 0 0 0-2.76-16Z",
    style: {
      fill: "#009fd6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.41 14.8a11.37 11.37 0 1 0 2.74 15.86 11.38 11.38 0 0 0-2.74-15.86Z",
    style: {
      fill: "#00a0d6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.35 14.89a11.26 11.26 0 1 0 2.71 15.7 11.28 11.28 0 0 0-2.71-15.7Z",
    style: {
      fill: "#00a0d6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.28 15A11.15 11.15 0 1 0 33 30.53 11.16 11.16 0 0 0 30.28 15Z",
    style: {
      fill: "#00a1d7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.21 15.07a11 11 0 1 0 2.66 15.39 11 11 0 0 0-2.66-15.39Z",
    style: {
      fill: "#00a1d7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.15 15.17a10.92 10.92 0 1 0 2.63 15.23 10.93 10.93 0 0 0-2.63-15.23Z",
    style: {
      fill: "#00a2d7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.08 15.26a10.81 10.81 0 1 0 2.61 15.07 10.8 10.8 0 0 0-2.61-15.07Z",
    style: {
      fill: "#00a2d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 15.35a10.7 10.7 0 1 0 2.6 14.92A10.71 10.71 0 0 0 30 15.35Z",
    style: {
      fill: "#00a3d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 15.44a10.58 10.58 0 1 0 2.5 14.76A10.58 10.58 0 0 0 30 15.44Z",
    style: {
      fill: "#00a4d8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.89 15.54a10.47 10.47 0 1 0 2.52 14.59 10.47 10.47 0 0 0-2.52-14.59Z",
    style: {
      fill: "#00a4d9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.82 15.63a10.35 10.35 0 1 0 2.5 14.44 10.36 10.36 0 0 0-2.5-14.44Z",
    style: {
      fill: "#00a5d9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.76 15.72A10.25 10.25 0 1 0 32.23 30a10.25 10.25 0 0 0-2.47-14.28Z",
    style: {
      fill: "#00a5d9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.69 15.81a10.13 10.13 0 1 0 2.44 14.13 10.13 10.13 0 0 0-2.44-14.13Z",
    style: {
      fill: "#00a6da",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.63 15.91a10 10 0 1 0 2.41 14 10 10 0 0 0-2.41-14Z",
    style: {
      fill: "#00a7da",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.56 16A9.9 9.9 0 1 0 32 29.81 9.91 9.91 0 0 0 29.56 16Z",
    style: {
      fill: "#00a7da",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 16.09a9.79 9.79 0 1 0 2.36 13.65 9.8 9.8 0 0 0-2.36-13.65Z",
    style: {
      fill: "#00a8db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.43 16.18a9.68 9.68 0 1 0 2.33 13.5 9.69 9.69 0 0 0-2.33-13.5Z",
    style: {
      fill: "#00a8db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.37 16.28a9.56 9.56 0 1 0 2.3 13.33 9.57 9.57 0 0 0-2.3-13.33Z",
    style: {
      fill: "#00a9db",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3 16.37a9.45 9.45 0 1 0 2.28 13.18 9.46 9.46 0 0 0-2.28-13.18Z",
    style: {
      fill: "#00aadc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.23 16.46a9.34 9.34 0 1 0 2.25 13 9.34 9.34 0 0 0-2.25-13Z",
    style: {
      fill: "#00aadc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.17 16.55a9.23 9.23 0 1 0 2.22 12.87 9.23 9.23 0 0 0-2.22-12.87Z",
    style: {
      fill: "#00abdc",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1 16.65a9.11 9.11 0 1 0 2.2 12.7 9.11 9.11 0 0 0-2.2-12.7Z",
    style: {
      fill: "#00abdd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 16.74a9 9 0 1 0 2.17 12.54A9 9 0 0 0 29 16.74Z",
    style: {
      fill: "#00acdd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 16.83a8.88 8.88 0 1 0 2.14 12.39A8.88 8.88 0 0 0 29 16.83Z",
    style: {
      fill: "#00addd",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.91 16.92A8.78 8.78 0 1 0 31 29.15a8.78 8.78 0 0 0-2.09-12.23Z",
    style: {
      fill: "#00adde",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.84 17a8.65 8.65 0 1 0 2.09 12.07A8.65 8.65 0 0 0 28.84 17Z",
    style: {
      fill: "#00aede",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.78 17.11A8.55 8.55 0 1 0 30.84 29a8.55 8.55 0 0 0-2.06-11.89Z",
    style: {
      fill: "#00aede",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.71 17.2a8.43 8.43 0 1 0 2 11.76 8.43 8.43 0 0 0-2-11.76Z",
    style: {
      fill: "#00afdf",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.65 17.29a8.32 8.32 0 1 0 2 11.6 8.32 8.32 0 0 0-2-11.6Z",
    style: {
      fill: "#00b0df",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.58 17.39a8.2 8.2 0 1 0 2 11.44 8.2 8.2 0 0 0-2-11.44Z",
    style: {
      fill: "#00b0df",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.52 17.48a8.09 8.09 0 1 0 1.95 11.28 8.1 8.1 0 0 0-1.95-11.28Z",
    style: {
      fill: "#00b1e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.45 17.57a8 8 0 1 0 1.92 11.13 8 8 0 0 0-1.92-11.13Z",
    style: {
      fill: "#00b2e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.39 17.66a7.87 7.87 0 1 0 1.89 11 7.88 7.88 0 0 0-1.89-11Z",
    style: {
      fill: "#00b2e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.32 17.76a7.75 7.75 0 1 0 1.87 10.81 7.75 7.75 0 0 0-1.87-10.81Z",
    style: {
      fill: "#00b3e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.26 17.85A7.64 7.64 0 1 0 30.1 28.5a7.65 7.65 0 0 0-1.84-10.65Z",
    style: {
      fill: "#00b3e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.19 17.94A7.53 7.53 0 1 0 30 28.43a7.53 7.53 0 0 0-1.81-10.49Z",
    style: {
      fill: "#00b4e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.12 18a7.42 7.42 0 1 0 1.79 10.34A7.42 7.42 0 0 0 28.12 18Z",
    style: {
      fill: "#00b4e2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.06 18.13a7.3 7.3 0 1 0 1.76 10.17 7.3 7.3 0 0 0-1.76-10.17Z",
    style: {
      fill: "#00b5e2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.09 17.93s-8.37-7.27-19.38-1S9.19 25 5.93 22.51l-5-3.78-.11.27 5 3.7s6.63 6 15-.42c6.64-5.07 16.87-9.64 24.12-4.19l2.2 1.63c0-.11-.05-.21-.07-.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8 23.88s-8.38-7.27-19.38-1-16.53 8-19.78 5.55l-.95-.7c0 .14 0 .28.07.41l.72.5s6.63 6 15-.42c6.64-5.07 16.87-9.64 24.12-4.19L47 28.9c0-.12.05-.24.07-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.07 16.78s6.63 6 15-.42c4.84-3.7 11.6-7.13 17.71-6.6a24 24 0 0 0-5-5A23.24 23.24 0 0 0 4.89 9.67a25.31 25.31 0 0 0-1.43 2.22Z",
    style: {
      fill: "#00b5e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 16.72s6.59 5.94 14.91-.42c4.81-3.67 11.53-7.09 17.62-6.55a24.06 24.06 0 0 0-4.93-5 23.2 23.2 0 0 0-34.17 7.11Z",
    style: {
      fill: "#00b5e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.33 16.66s6.56 5.9 14.82-.41c4.79-3.66 11.47-7 17.52-6.52a23.77 23.77 0 0 0-4.9-5A23 23 0 0 0 5.2 9.64a25.45 25.45 0 0 0-1.41 2.19Z",
    style: {
      fill: "#00b6e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.46 16.61s6.54 5.86 14.74-.42c4.76-3.63 11.4-7 17.41-6.48a23.73 23.73 0 0 0-4.87-4.94A22.84 22.84 0 0 0 5.36 9.62 24.35 24.35 0 0 0 4 11.8Z",
    style: {
      fill: "#00b6e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.59 16.55s6.48 5.83 14.65-.41c4.73-3.62 11.34-7 17.32-6.45a24 24 0 0 0-4.85-4.91A22.72 22.72 0 0 0 5.52 9.6a24.09 24.09 0 0 0-1.39 2.17Z",
    style: {
      fill: "#00b6e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.72 16.49s6.44 5.8 14.56-.41C30 12.49 36.56 9.16 42.5 9.68a23.21 23.21 0 0 0-4.82-4.88 22.69 22.69 0 0 0-33.39 7Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.84 16.44s6.41 5.76 14.49-.44c4.67-3.54 11.2-6.86 17.11-6.34a22.92 22.92 0 0 0-4.79-4.85A22.43 22.43 0 0 0 5.84 9.57a20.59 20.59 0 0 0-1.38 2.15Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16.38s6.37 5.73 14.4-.41c4.65-3.55 11.14-6.84 17-6.33a23.41 23.41 0 0 0-4.77-4.82A22.32 22.32 0 0 0 6 9.55c-.5.7-1 1.41-1.37 2.14Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 16.32s6.33 5.7 14.31-.4c4.59-3.53 11.08-6.81 16.92-6.3a23.32 23.32 0 0 0-4.73-4.79A22.18 22.18 0 0 0 6.15 9.54a20.6 20.6 0 0 0-1.36 2.12Z",
    style: {
      fill: "#00b7e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.23 16.26s6.29 5.67 14.23-.4c4.59-3.5 11-6.76 16.81-6.25a22.59 22.59 0 0 0-4.7-4.77A22.05 22.05 0 0 0 6.31 9.52 19.79 19.79 0 0 0 5 11.63Z",
    style: {
      fill: "#00b8e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.36 16.21s6.25 5.63 14.14-.4c4.57-3.49 11-6.73 16.72-6.22a22.83 22.83 0 0 0-4.68-4.74A21.92 21.92 0 0 0 6.47 9.5a21.36 21.36 0 0 0-1.35 2.1Z",
    style: {
      fill: "#00b8e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.49 16.15s6.21 5.6 14.05-.4c4.55-3.46 10.88-6.68 16.62-6.18a22.79 22.79 0 0 0-4.65-4.71A21.8 21.8 0 0 0 6.62 9.48a24.48 24.48 0 0 0-1.33 2.09Z",
    style: {
      fill: "#00b8e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.61 16.09s6.18 5.57 14-.39C30.1 12.25 36.4 9.06 42.1 9.55a22.25 22.25 0 0 0-4.62-4.68 21.66 21.66 0 0 0-30.7 4.6 22.71 22.71 0 0 0-1.33 2.07Z",
    style: {
      fill: "#00b9e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.74 16s6.15 5.52 13.89-.39C30.12 12.22 36.38 9 42 9.54a22 22 0 0 0-4.59-4.66A21.53 21.53 0 0 0 6.94 9.45a23.9 23.9 0 0 0-1.32 2.06Z",
    style: {
      fill: "#00b9e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.87 16s6.11 5.49 13.81-.39C30.13 12.19 36.36 9 42 9.52a22 22 0 0 0-4.58-4.62A21.39 21.39 0 0 0 7.1 9.43a23.75 23.75 0 0 0-1.32 2.05Z",
    style: {
      fill: "#04b9e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.92s6.07 5.46 13.72-.38c4.43-3.39 10.61-6.53 16.21-6a21.69 21.69 0 0 0-4.54-4.59A21.39 21.39 0 0 0 6 11.45Z",
    style: {
      fill: "#0cbae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.13 15.86s6 5.43 13.63-.38c4.41-3.36 10.55-6.48 16.11-6a21.64 21.64 0 0 0-4.5-4.57 21.14 21.14 0 0 0-30 4.48 22.93 22.93 0 0 0-1.29 2Z",
    style: {
      fill: "#13bae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.26 15.81s6 5.39 13.55-.38c4.37-3.35 10.48-6.45 16-6a21.64 21.64 0 0 0-4.48-4.54A21 21 0 0 0 7.57 9.38q-.71 1-1.29 2Z",
    style: {
      fill: "#18bae4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 15.75s5.95 5.36 13.46-.38C30.2 12.05 36.27 9 41.76 9.45a21.6 21.6 0 0 0-4.45-4.51A20.86 20.86 0 0 0 7.73 9.37a20.32 20.32 0 0 0-1.28 2Z",
    style: {
      fill: "#1dbae5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.51 15.69s5.92 5.33 13.38-.37C30.21 12 36.25 9 41.7 9.43A21.3 21.3 0 0 0 37.28 5 20.74 20.74 0 0 0 7.89 9.35a22.21 22.21 0 0 0-1.28 2Z",
    style: {
      fill: "#20bbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.64 15.64s5.88 5.29 13.3-.38C30.23 12 36.22 8.94 41.65 9.42A21.12 21.12 0 0 0 37.25 5 20.61 20.61 0 0 0 8 9.33a21.83 21.83 0 0 0-1.26 2Z",
    style: {
      fill: "#24bbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.77 15.58s5.84 5.26 13.21-.37C30.25 12 36.2 8.93 41.59 9.4A21.07 21.07 0 0 0 37.22 5a20.47 20.47 0 0 0-29 4.35A19.46 19.46 0 0 0 7 11.27Z",
    style: {
      fill: "#27bbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 15.52s5.8 5.23 13.12-.37c4.24-3.23 10.16-6.24 15.51-5.77A21 21 0 0 0 37.19 5 20.34 20.34 0 0 0 8.36 9.3a21.28 21.28 0 0 0-1.25 1.94Z",
    style: {
      fill: "#2abce5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.46s5.76 5.2 13-.36c4.21-3.22 10.09-6.2 15.41-5.74A20.75 20.75 0 0 0 37.16 5 20.2 20.2 0 0 0 8.52 9.28a19.23 19.23 0 0 0-1.24 1.94Z",
    style: {
      fill: "#2dbce5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.16 15.41s5.73 5.15 13-.37c4.19-3.19 10-6.16 15.31-5.69A20.46 20.46 0 0 0 37.14 5 20.07 20.07 0 0 0 8.68 9.27a19.6 19.6 0 0 0-1.24 1.92Z",
    style: {
      fill: "#2fbce5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28 15.35S19 20.47 26.15 15c4.16-3.18 10-6.12 15.21-5.66A20.65 20.65 0 0 0 37.11 5 20 20 0 0 0 8.83 9.25a22.8 22.8 0 0 0-1.22 1.91Z",
    style: {
      fill: "#32bde5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.41 15.29s5.66 5.09 12.79-.36c4.13-3.15 9.89-6.07 15.11-5.62A20.66 20.66 0 0 0 37.08 5 19.82 19.82 0 0 0 9 9.23a20.25 20.25 0 0 0-1.21 1.9Z",
    style: {
      fill: "#34bde6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.54 15.24s5.62 5 12.7-.36c4.1-3.13 9.83-6 15-5.59A20.37 20.37 0 0 0 37.05 5a19.67 19.67 0 0 0-27.9 4.22 22.2 22.2 0 0 0-1.21 1.88Z",
    style: {
      fill: "#36bde6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.67 15.18s5.58 5 12.62-.36c4.07-3.11 9.76-6 14.9-5.54A20.12 20.12 0 0 0 37 5.05a19.63 19.63 0 0 0-28.91 6Z",
    style: {
      fill: "#38bee6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15.12s5.54 5 12.53-.35c4.05-3.09 9.69-6 14.81-5.51A20.38 20.38 0 0 0 37 5.06 19.54 19.54 0 0 0 8.27 11Z",
    style: {
      fill: "#3abee6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.93 15.06s5.5 5 12.44-.34c4-3.07 9.63-5.92 14.71-5.48A19.84 19.84 0 0 0 37 5.07 19.29 19.29 0 0 0 9.62 9.16 21.37 21.37 0 0 0 8.44 11Z",
    style: {
      fill: "#3cbee6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06 15s5.46 4.92 12.36-.35c4-3.05 9.56-5.88 14.6-5.44a19.56 19.56 0 0 0-4.09-4.14A19.16 19.16 0 0 0 9.78 9.15 18.83 18.83 0 0 0 8.61 11Z",
    style: {
      fill: "#3ebee6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.18 15s5.43 4.89 12.28-.34c4-3 9.5-5.84 14.51-5.4a19.75 19.75 0 0 0-4.06-4.16 19 19 0 0 0-27 4A18.7 18.7 0 0 0 8.77 11Z",
    style: {
      fill: "#40bfe6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31 14.89s5.39 4.86 12.19-.34c3.94-3 9.44-5.79 14.41-5.36a19.47 19.47 0 0 0-4-4.08 18.89 18.89 0 0 0-26.78 4 19.73 19.73 0 0 0-1.16 1.81Z",
    style: {
      fill: "#42bfe7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.44 14.84s5.35 4.82 12.11-.34c3.91-3 9.36-5.76 14.3-5.33a19.18 19.18 0 0 0-4-4 18.76 18.76 0 0 0-26.6 4 20.1 20.1 0 0 0-1.15 1.72Z",
    style: {
      fill: "#44bfe7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.57 14.78s5.32 4.78 12-.34c3.88-3 9.3-5.71 14.21-5.28a19.47 19.47 0 0 0-4-4 18.63 18.63 0 0 0-26.41 4 19.07 19.07 0 0 0-1.14 1.78Z",
    style: {
      fill: "#46c0e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 14.72s5.28 4.75 11.93-.33c3.86-3 9.24-5.68 14.11-5.25a19.18 19.18 0 0 0-4-4 18.5 18.5 0 0 0-26.17 3.92c-.42.58-.79 1.17-1.14 1.77Z",
    style: {
      fill: "#47c0e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.83 14.67s5.24 4.71 11.85-.34c3.82-2.92 9.17-5.63 14-5.21a18.9 18.9 0 0 0-3.92-4 18.36 18.36 0 0 0-26 3.9A19.28 19.28 0 0 0 9.6 10.8Z",
    style: {
      fill: "#49c0e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.61s5.21 4.68 11.77-.33c3.8-2.9 9.1-5.6 13.9-5.18a18.85 18.85 0 0 0-3.89-3.94 18.32 18.32 0 0 0-27 5.61Z",
    style: {
      fill: "#4bc1e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.08 14.55s5.17 4.65 11.68-.33c3.78-2.88 9-5.55 13.81-5.13a19.1 19.1 0 0 0-3.86-3.92A18.11 18.11 0 0 0 11 9c-.4.57-.77 1.14-1.11 1.73Z",
    style: {
      fill: "#4cc1e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.21 14.49s5.13 4.62 11.6-.32c3.74-2.86 9-5.52 13.7-5.1a18.81 18.81 0 0 0-3.83-3.89A18 18 0 0 0 11.2 9a17.27 17.27 0 0 0-1.1 1.72Z",
    style: {
      fill: "#4ec1e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.34 14.44s5.09 4.58 11.51-.33c3.72-2.84 8.91-5.47 13.6-5.06a18.51 18.51 0 0 0-3.8-3.86A17.85 17.85 0 0 0 11.36 9a17.13 17.13 0 0 0-1.1 1.71Z",
    style: {
      fill: "#4fc1e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.47 14.38s5 4.55 11.42-.32c3.7-2.82 8.85-5.43 13.51-5a18.48 18.48 0 0 0-3.78-3.82A17.7 17.7 0 0 0 11.52 9a18.11 18.11 0 0 0-1.09 1.7Z",
    style: {
      fill: "#51c2e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 14.32s5 4.52 11.34-.32c3.66-2.79 8.77-5.39 13.4-5a18 18 0 0 0-3.75-3.8A17.58 17.58 0 0 0 11.67 9a16.44 16.44 0 0 0-1.07 1.68Z",
    style: {
      fill: "#52c2e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.73 14.27S20.7 18.75 27 14c3.62-2.83 8.69-5.4 13.28-5a17.71 17.71 0 0 0-3.72-3.77 17.5 17.5 0 0 0-25.8 5.37Z",
    style: {
      fill: "#54c2e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.85 14.21s4.94 4.45 11.18-.32c3.6-2.75 8.64-5.31 13.2-4.91a17.71 17.71 0 0 0-3.7-3.74 17.34 17.34 0 0 0-25.6 5.33Z",
    style: {
      fill: "#55c3e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.15s4.91 4.41 11.09-.31c3.58-2.73 8.58-5.27 13.1-4.88a17.66 17.66 0 0 0-3.69-3.71A17.18 17.18 0 0 0 12.15 8.9a16.94 16.94 0 0 0-1.06 1.64Z",
    style: {
      fill: "#57c3e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.11 14.09s4.87 4.38 11-.31c3.56-2.71 8.52-5.23 13-4.83a17.61 17.61 0 0 0-3.63-3.69 17 17 0 0 0-24.17 3.62 15 15 0 0 0-1.05 1.63Z",
    style: {
      fill: "#58c3e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.24 14s4.83 4.34 10.92-.31c3.52-2.69 8.44-5.19 12.9-4.8a17.62 17.62 0 0 0-3.61-3.66 16.93 16.93 0 0 0-24 3.59 17.61 17.61 0 0 0-1 1.62Z",
    style: {
      fill: "#59c4e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.37 14s4.79 4.31 10.83-.3C30.7 11 35.58 8.53 40 8.91a17.57 17.57 0 0 0-3.58-3.63 16.8 16.8 0 0 0-23.8 3.56c-.37.53-.72 1.06-1 1.61Z",
    style: {
      fill: "#5bc4e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.92s4.75 4.28 10.74-.3c3.47-2.65 8.32-5.11 12.7-4.73a17.53 17.53 0 0 0-3.55-3.6 16.66 16.66 0 0 0-23.61 3.54q-.55.78-1 1.59Z",
    style: {
      fill: "#5cc4e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.62 13.87s4.72 4.24 10.67-.3c3.44-2.63 8.25-5.07 12.6-4.69a16.81 16.81 0 0 0-3.53-3.57 16.51 16.51 0 0 0-23.42 3.5 17.69 17.69 0 0 0-1 1.58Z",
    style: {
      fill: "#5dc4e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 13.81s4.68 4.21 10.58-.3c3.42-2.61 8.18-5 12.5-4.65a16.53 16.53 0 0 0-3.5-3.54A16.39 16.39 0 0 0 13.1 8.79a16.68 16.68 0 0 0-1 1.57Z",
    style: {
      fill: "#5fc5e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 13.75s4.64 4.18 10.49-.29c3.39-2.59 8.12-5 12.4-4.62a16.71 16.71 0 0 0-3.47-3.51 16.26 16.26 0 0 0-23 3.45 16.91 16.91 0 0 0-1 1.55Z",
    style: {
      fill: "#60c5e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13.69s4.6 4.15 10.41-.29c3.36-2.56 8-5 12.3-4.58a16.72 16.72 0 0 0-3.45-3.48 16.12 16.12 0 0 0-22.85 3.42 18.24 18.24 0 0 0-1 1.54Z",
    style: {
      fill: "#61c5e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.14 13.64s4.56 4.11 10.32-.29c3.34-2.55 8-4.91 12.2-4.54a16.43 16.43 0 0 0-3.41-3.46 16 16 0 0 0-22.68 3.39 15.79 15.79 0 0 0-1 1.53Z",
    style: {
      fill: "#63c6e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.27 13.58s4.52 4.08 10.23-.29c3.31-2.52 7.93-4.86 12.1-4.5a16.63 16.63 0 0 0-3.38-3.43 15.86 15.86 0 0 0-22.49 3.37 17.66 17.66 0 0 0-1 1.51Z",
    style: {
      fill: "#64c6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 13.52s4.49 4 10.15-.28c3.28-2.51 7.85-4.83 12-4.47a16.64 16.64 0 0 0-3.36-3.4 15.74 15.74 0 0 0-22.31 3.34 17.25 17.25 0 0 0-1 1.5Z",
    style: {
      fill: "#65c6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.52 13.47s4.46 4 10.07-.29c3.25-2.48 7.79-4.78 11.9-4.42a16.15 16.15 0 0 0-3.33-3.38A15.62 15.62 0 0 0 14 8.69a17.25 17.25 0 0 0-1 1.5Z",
    style: {
      fill: "#66c7ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65 13.41s4.42 4 10-.28c3.22-2.46 7.72-4.75 11.79-4.39a15.86 15.86 0 0 0-3.3-3.35 15.54 15.54 0 0 0-22.88 4.77Z",
    style: {
      fill: "#68c7ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78 13.35s4.38 3.94 9.9-.28c3.2-2.44 7.66-4.7 11.69-4.35a15.77 15.77 0 0 0-3.27-3.31 15.33 15.33 0 0 0-21.74 3.25 14.56 14.56 0 0 0-.94 1.47Z",
    style: {
      fill: "#69c7ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 13.29s4.34 3.91 9.81-.27c3.17-2.42 7.59-4.67 11.6-4.32a15.78 15.78 0 0 0-3.25-3.28 15.2 15.2 0 0 0-21.55 3.22 14.44 14.44 0 0 0-.94 1.46Z",
    style: {
      fill: "#6ac8ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.24s4.3 3.87 9.73-.28c3.14-2.4 7.52-4.62 11.49-4.27a15.22 15.22 0 0 0-24.59-.06 16.71 16.71 0 0 0-.92 1.44Z",
    style: {
      fill: "#6bc8ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.17 13.18s4.26 3.84 9.64-.27c3.11-2.38 7.46-4.59 11.39-4.24A15.2 15.2 0 0 0 36 5.44a14.94 14.94 0 0 0-21.17 3.17 16.55 16.55 0 0 0-.92 1.39Z",
    style: {
      fill: "#6cc8eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29 13.12s4.23 3.81 9.56-.27c3.09-2.35 7.4-4.54 11.3-4.2A15.44 15.44 0 0 0 36 5.45a14.82 14.82 0 0 0-21 3.14 15.48 15.48 0 0 0-.92 1.41Z",
    style: {
      fill: "#6ec9eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.42 13.07s4.19 3.77 9.48-.27c3.1-2.34 7.33-4.5 11.19-4.17A15.15 15.15 0 0 0 36 5.46a14.68 14.68 0 0 0-20.85 3.12 13.86 13.86 0 0 0-.9 1.4Z",
    style: {
      fill: "#6fc9eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.55 13s4.15 3.74 9.39-.26C31 10.43 35.2 8.28 39 8.62a14.91 14.91 0 0 0-3.1-3.15 14.55 14.55 0 0 0-20.6 3.09c-.32.45-.62.92-.89 1.39Z",
    style: {
      fill: "#70c9eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.68 13s4.11 3.71 9.3-.26c3-2.29 7.2-4.42 11-4.09a15.16 15.16 0 0 0-3.08-3.17 14.44 14.44 0 0 0-21.32 4.44Z",
    style: {
      fill: "#71caeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.81 12.89s4.08 3.67 9.22-.25c3-2.28 7.13-4.39 10.89-4.06a14.87 14.87 0 0 0-3.05-3.09 14.29 14.29 0 0 0-20.25 3c-.32.45-.61.91-.88 1.37Z",
    style: {
      fill: "#72caeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.94 12.84s4 3.63 9.13-.26c2.95-2.25 7.07-4.34 10.79-4a14.83 14.83 0 0 0-3-3.06 14.24 14.24 0 0 0-20.95 4.34Z",
    style: {
      fill: "#73caeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07 12.78s4 3.6 9-.25c2.93-2.24 7-4.31 10.7-4a14.35 14.35 0 0 0-3-3 14 14 0 0 0-19.87 3 13.15 13.15 0 0 0-.86 1.34Z",
    style: {
      fill: "#74cbeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.19 12.72s4 3.57 9-.25c2.89-2.21 6.93-4.26 10.59-3.94a14.5 14.5 0 0 0-3-3 13.9 13.9 0 0 0-19.7 2.94c-.31.44-.59.88-.85 1.33Z",
    style: {
      fill: "#76cbec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 12.67s3.93 3.53 8.88-.25c2.87-2.19 6.87-4.22 10.49-3.91a14.45 14.45 0 0 0-2.93-3 13.76 13.76 0 0 0-19.51 2.95 12.11 12.11 0 0 0-.84 1.31Z",
    style: {
      fill: "#77cbec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.45 12.61s3.89 3.5 8.79-.25c2.85-2.17 6.81-4.18 10.4-3.87a14.21 14.21 0 0 0-2.91-2.94 13.63 13.63 0 0 0-19.32 2.89 15.12 15.12 0 0 0-.84 1.3Z",
    style: {
      fill: "#78cbec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.58 12.55s3.85 3.47 8.71-.24C31.1 10.16 35 8.17 38.58 8.48a14 14 0 0 0-2.88-2.92 13.5 13.5 0 0 0-19.13 2.86 14.84 14.84 0 0 0-.83 1.29Z",
    style: {
      fill: "#79ccec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.71 12.5s3.81 3.43 8.62-.25c2.79-2.12 6.67-4.1 10.19-3.79a13.92 13.92 0 0 0-2.85-2.89 13.35 13.35 0 0 0-18.94 2.84 11.56 11.56 0 0 0-.82 1.28Z",
    style: {
      fill: "#7accec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.84 12.44s3.77 3.4 8.54-.24c2.75-2.11 6.6-4.06 10.09-3.76a13.69 13.69 0 0 0-2.83-2.86 13.24 13.24 0 0 0-18.76 2.81c-.29.41-.56.83-.81 1.27Z",
    style: {
      fill: "#7bccec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.38s3.73 3.37 8.45-.24c2.73-2.08 6.54-4 10-3.71A13.22 13.22 0 0 0 17 8.37a14 14 0 0 0-.8 1.26Z",
    style: {
      fill: "#7ccdec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.09 12.32s3.71 3.34 8.37-.23c2.71-2.07 6.48-4 9.89-3.68a13.59 13.59 0 0 0-2.76-2.81A13 13 0 0 0 17.2 8.36a12.47 12.47 0 0 0-.8 1.24Z",
    style: {
      fill: "#7dcded"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.22 12.27s3.67 3.29 8.29-.24c2.67-2 6.41-3.93 9.79-3.64a13.31 13.31 0 0 0-2.74-2.77 12.84 12.84 0 0 0-18.2 2.72 13.48 13.48 0 0 0-.79 1.23Z",
    style: {
      fill: "#7ecded"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.35 12.21s3.65 3.26 8.2-.21c2.65-2 6.34-3.9 9.69-3.61a13 13 0 0 0-2.71-2.74 12.71 12.71 0 0 0-18 2.69c-.28.4-.54.8-.78 1.22Z",
    style: {
      fill: "#7fceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.48 12.15s3.59 3.23 8.11-.23c2.62-2 6.28-3.85 9.59-3.56a13 13 0 0 0-2.68-2.72 12.58 12.58 0 0 0-17.83 2.67 12.82 12.82 0 0 0-.77 1.2Z",
    style: {
      fill: "#80ceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.61 12.1s3.55 3.19 8-.23c2.59-2 6.21-3.82 9.49-3.53a13 13 0 0 0-2.66-2.69 12.47 12.47 0 0 0-18.4 3.83Z",
    style: {
      fill: "#81ceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.74 12s3.51 3.16 7.94-.22c2.57-2 6.15-3.78 9.39-3.5a12.5 12.5 0 0 0-2.63-2.66 12.38 12.38 0 0 0-18.21 3.83Z",
    style: {
      fill: "#82ceed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.86 12s3.48 3.13 7.86-.22C31.26 9.82 34.8 8 38 8.3a12.45 12.45 0 0 0-2.6-2.63 12.18 12.18 0 0 0-17.25 2.58 10.51 10.51 0 0 0-.75 1.17Z",
    style: {
      fill: "#83cfed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.92s3.44 3.1 7.78-.21c2.51-1.92 6-3.7 9.18-3.42a12.21 12.21 0 0 0-2.57-2.61A12.05 12.05 0 0 0 18.3 8.24c-.27.37-.51.76-.74 1.15Z",
    style: {
      fill: "#84cfed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.12 11.87s3.4 3.06 7.69-.22c2.48-1.9 5.95-3.65 9.09-3.38a12.41 12.41 0 0 0-2.54-2.58 11.93 11.93 0 0 0-16.9 2.53 11.56 11.56 0 0 0-.73 1.14Z",
    style: {
      fill: "#85cfee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 11.81s3.36 3 7.6-.21c2.46-1.88 5.89-3.62 9-3.35a12.12 12.12 0 0 0-2.52-2.55 11.8 11.8 0 0 0-16.71 2.5 12.6 12.6 0 0 0-.72 1.13Z",
    style: {
      fill: "#86d0ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38 11.75s3.32 3 7.52-.21c2.43-1.85 5.82-3.54 8.88-3.31a12 12 0 0 0-2.48-2.51 11.65 11.65 0 0 0-16.52 2.47 13.14 13.14 0 0 0-.72 1.11Z",
    style: {
      fill: "#87d0ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.51 11.7s3.29 3 7.43-.21c2.4-1.84 5.75-3.54 8.79-3.27a11.84 11.84 0 0 0-2.46-2.49 11.53 11.53 0 0 0-16.34 2.44c-.25.36-.49.73-.7 1.1Z",
    style: {
      fill: "#88d0ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.64 11.64s3.25 2.92 7.35-.21c2.37-1.81 5.68-3.49 8.68-3.23a11.56 11.56 0 0 0-2.43-2.46 11.4 11.4 0 0 0-16.15 2.41c-.25.36-.49.72-.7 1.09Z",
    style: {
      fill: "#89d1ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.76 11.58s3.24 2.89 7.24-.2c2.35-1.79 5.62-3.46 8.58-3.2a11.51 11.51 0 0 0-2.4-2.43 11.26 11.26 0 0 0-16 2.39c-.25.35-.48.71-.69 1.07Z",
    style: {
      fill: "#89d1ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.89 11.52s3.18 2.86 7.18-.2c2.32-1.77 5.56-3.41 8.49-3.16a11.76 11.76 0 0 0-2.38-2.4 11.16 11.16 0 0 0-16.45 3.42Z",
    style: {
      fill: "#8ad1ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.47s3.14 2.82 7.1-.2c2.29-1.75 5.49-3.38 8.38-3.12a11.27 11.27 0 0 0-2.35-2.38A11 11 0 0 0 19.57 8.1a11.14 11.14 0 0 0-.68 1.06Z",
    style: {
      fill: "#8bd1ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.15 11.41s3.1 2.79 7-.2c2.26-1.73 5.42-3.33 8.28-3.08a11.17 11.17 0 0 0-2.31-2.35 10.88 10.88 0 0 0-15.4 2.31 10.15 10.15 0 0 0-.66 1Z",
    style: {
      fill: "#8cd2ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.28 11.35s3.06 2.76 6.92-.19c2.24-1.71 5.36-3.29 8.19-3.05a11.43 11.43 0 0 0-2.29-2.32 10.74 10.74 0 0 0-15.22 2.28 11.23 11.23 0 0 0-.66 1Z",
    style: {
      fill: "#8dd2ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.41 11.3s3 2.72 6.84-.2c2.21-1.68 5.29-3.25 8.08-3a10.94 10.94 0 0 0-2.26-2.3A10.62 10.62 0 0 0 20 8.05a11 11 0 0 0-.65 1Z",
    style: {
      fill: "#8ed2ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.53 11.24s3 2.69 6.76-.19c2.18-1.67 5.23-3.21 8-3A10.61 10.61 0 0 0 35 5.82 10.46 10.46 0 0 0 20.2 8a8.89 8.89 0 0 0-.64 1Z",
    style: {
      fill: "#8fd3ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.66 11.18s2.95 2.66 6.67-.19c2.16-1.64 5.16-3.17 7.89-2.93A10.61 10.61 0 0 0 35 5.83 10.33 10.33 0 0 0 20.36 8a8.77 8.77 0 0 0-.64 1Z",
    style: {
      fill: "#90d3ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.79 11.12s2.91 2.63 6.59-.18C31.5 9.32 34.47 7.81 37.16 8A10.56 10.56 0 0 0 35 5.84 10.21 10.21 0 0 0 20.51 8c-.22.32-.43.65-.62 1Z",
    style: {
      fill: "#91d3ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.92 11.07a5 5 0 0 0 6.5-.19c2.1-1.6 5-3.09 7.68-2.85A10.32 10.32 0 0 0 35 5.85 10.07 10.07 0 0 0 20.67 8c-.22.31-.43.63-.62 1Z",
    style: {
      fill: "#92d3ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.05 11a5 5 0 0 0 6.41-.18c2.08-1.58 5-3 7.59-2.82a10.33 10.33 0 0 0-2.13-2.15A9.94 9.94 0 0 0 20.83 8a10.88 10.88 0 0 0-.61 1Z",
    style: {
      fill: "#92d4ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.18 11a4.89 4.89 0 0 0 6.33-.17c2-1.57 4.9-3 7.48-2.79a10.49 10.49 0 0 0-2.09-2.17A9.82 9.82 0 0 0 21 8a10.61 10.61 0 0 0-.6.94Z",
    style: {
      fill: "#93d4f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.31 10.9a4.82 4.82 0 0 0 6.24-.18c2-1.54 4.83-3 7.38-2.75a10.45 10.45 0 0 0-2.06-2.09 9.7 9.7 0 0 0-13.73 2.05c-.21.31-.41.62-.59.93Z",
    style: {
      fill: "#94d4f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.43 10.84a4.76 4.76 0 0 0 6.16-.17c2-1.52 4.77-2.93 7.29-2.71a10.25 10.25 0 0 0-2-2.07 9.55 9.55 0 0 0-13.54 2 9.93 9.93 0 0 0-.58.91Z",
    style: {
      fill: "#95d5f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.56 10.78a4.69 4.69 0 0 0 6.08-.17c2-1.5 4.7-2.89 7.18-2.67a9.71 9.71 0 0 0-2-2 9.43 9.43 0 0 0-13.35 2c-.21.29-.4.6-.58.9Z",
    style: {
      fill: "#96d5f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.69 10.72a4.62 4.62 0 0 0 6-.16c1.94-1.48 4.64-2.85 7.08-2.64a9.91 9.91 0 0 0-2-2 9.3 9.3 0 0 0-13.16 2 9.53 9.53 0 0 0-.57.89Z",
    style: {
      fill: "#97d5f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.82 10.67a4.56 4.56 0 0 0 5.91-.17c1.9-1.45 4.57-2.81 7-2.6a9.38 9.38 0 0 0-2-2 9.14 9.14 0 0 0-13 1.94 8.13 8.13 0 0 0-.57.87Z",
    style: {
      fill: "#98d5f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10.61a4.49 4.49 0 0 0 5.82-.16c1.88-1.44 4.5-2.77 6.88-2.56a8.92 8.92 0 0 0-1.93-1.95 9 9 0 0 0-12.84 1.91c-.2.28-.38.57-.55.86Z",
    style: {
      fill: "#98d6f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.08 10.55a4.41 4.41 0 0 0 5.73-.16c1.86-1.39 4.44-2.73 6.78-2.52A9.28 9.28 0 0 0 34.7 6a8.9 8.9 0 0 0-12.61 1.83 8.65 8.65 0 0 0-.54.85Z",
    style: {
      fill: "#99d6f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 10.5a4.37 4.37 0 0 0 5.66-.16c1.82-1.4 4.37-2.69 6.67-2.49A9 9 0 0 0 34.67 6a8.76 8.76 0 0 0-12.42 1.82 7.48 7.48 0 0 0-.54.84Z",
    style: {
      fill: "#9ad6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.33 10.44a4.3 4.3 0 0 0 5.57-.16c1.8-1.37 4.31-2.64 6.58-2.45A9 9 0 0 0 34.64 6a8.63 8.63 0 0 0-12.23 1.8 7.28 7.28 0 0 0-.53.83Z",
    style: {
      fill: "#9bd7f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.46 10.38a4.24 4.24 0 0 0 5.48-.15c1.77-1.35 4.24-2.61 6.48-2.41A8.76 8.76 0 0 0 34.61 6a8.49 8.49 0 0 0-12 1.8 8.15 8.15 0 0 0-.61.8Z",
    style: {
      fill: "#9cd7f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.59 10.33a4.18 4.18 0 0 0 5.4-.16c1.74-1.33 4.17-2.56 6.37-2.37A8.71 8.71 0 0 0 34.58 6a8.38 8.38 0 0 0-12.37 2.57Z",
    style: {
      fill: "#9dd7f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.72 10.27a4.1 4.1 0 0 0 5.28-.15c1.72-1.31 4.11-2.53 6.28-2.34A8.72 8.72 0 0 0 34.55 6a8.23 8.23 0 0 0-11.67 1.75c-.18.26-.35.52-.5.79Z",
    style: {
      fill: "#9ed8f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.85 10.21a4 4 0 0 0 5.22-.15c1.69-1.29 4-2.48 6.18-2.29A8 8 0 0 0 34.52 6 8.1 8.1 0 0 0 23 7.73a7.94 7.94 0 0 0-.5.78Z",
    style: {
      fill: "#9ed8f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 10.15a4 4 0 0 0 5.12-.15c1.66-1.27 4-2.45 6.07-2.26A7.7 7.7 0 0 0 34.49 6 8 8 0 0 0 23.2 7.72a7.57 7.57 0 0 0-.49.76Z",
    style: {
      fill: "#9fd8f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 10.1a3.91 3.91 0 0 0 5.06-.1c1.63-1.24 3.91-2.4 6-2.22A8.1 8.1 0 0 0 34.47 6a7.84 7.84 0 0 0-11.12 1.7q-.26.36-.48.75Z",
    style: {
      fill: "#a0d8f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.23 10a3.83 3.83 0 0 0 5-.14c1.61-1.23 3.85-2.36 5.88-2.19a7.81 7.81 0 0 0-1.64-1.66 7.71 7.71 0 0 0-10.96 1.67 8.35 8.35 0 0 0-.47.74Z",
    style: {
      fill: "#a1d9f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 10a3.77 3.77 0 0 0 4.89-.13C31.83 8.64 34 7.52 36 7.7a7.63 7.63 0 0 0-12.35 0 6.76 6.76 0 0 0-.46.72Z",
    style: {
      fill: "#a2d9f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.49 9.93a3.7 3.7 0 0 0 4.8-.14C31.84 8.61 34 7.51 36 7.68a7.82 7.82 0 0 0-1.59-1.61 7.44 7.44 0 0 0-10.58 1.58 7.8 7.8 0 0 0-.46.71Z",
    style: {
      fill: "#a2d9f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.62 9.87a3.64 3.64 0 0 0 4.72-.13c1.52-1.17 3.66-2.25 5.57-2.08a7.53 7.53 0 0 0-1.56-1.58A7.3 7.3 0 0 0 24 7.63a5.92 5.92 0 0 0-.45.7Z",
    style: {
      fill: "#a3daf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75 9.81a3.57 3.57 0 0 0 4.63-.13 8.64 8.64 0 0 1 5.47-2 7.48 7.48 0 0 0-1.53-1.55 7.19 7.19 0 0 0-10.18 1.48c-.16.23-.3.46-.44.69Z",
    style: {
      fill: "#a4daf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.87 9.75a3.52 3.52 0 0 0 4.55-.12 8.36 8.36 0 0 1 5.38-2 7.29 7.29 0 0 0-1.51-1.53 7 7 0 0 0-10 1.5 6.9 6.9 0 0 0-.43.67Z",
    style: {
      fill: "#a5daf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 9.7a3.46 3.46 0 0 0 4.47-.13 8.27 8.27 0 0 1 5.27-2 7.25 7.25 0 0 0-1.48-1.5 6.91 6.91 0 0 0-9.8 1.47 6 6 0 0 0-.42.66Z",
    style: {
      fill: "#a6daf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.13 9.64a3.39 3.39 0 0 0 4.38-.12 8.16 8.16 0 0 1 5.17-1.93 7.11 7.11 0 0 0-1.44-1.46 6.79 6.79 0 0 0-9.62 1.43c-.15.22-.29.43-.42.65Z",
    style: {
      fill: "#a6dbf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.26 9.58a3.31 3.31 0 0 0 4.29-.12 8 8 0 0 1 5.08-1.89 6.87 6.87 0 0 0-1.42-1.43 6.65 6.65 0 0 0-9.44 1.41c-.14.2-.28.42-.4.63Z",
    style: {
      fill: "#a7dbf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.39 9.53a3.26 3.26 0 0 0 4.21-.12 7.79 7.79 0 0 1 5-1.85 6.63 6.63 0 0 0-1.39-1.41 6.52 6.52 0 0 0-9.25 1.38c-.14.2-.28.41-.4.62Z",
    style: {
      fill: "#a8dbf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.52 9.47a3.18 3.18 0 0 0 4.12-.12 7.67 7.67 0 0 1 4.87-1.81 6.58 6.58 0 0 0-1.36-1.38 6.39 6.39 0 0 0-9.06 1.35c-.14.2-.27.41-.39.62Z",
    style: {
      fill: "#a9dcf3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 29.82s-8.37-7.26-19.38-1C10.93 32.4 6.48 34.49 3.19 35.2a24.11 24.11 0 0 0 6.84 8 23.33 23.33 0 0 0 34.49-7.39Z",
    style: {
      fill: "#005faa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.24 29.89s-8.3-7.21-19.21-1c-6.13 3.55-10.55 5.62-13.81 6.33A23.87 23.87 0 0 0 10 43.16a23 23 0 0 0 32.65-4.88 24.28 24.28 0 0 0 1.54-2.44Z",
    style: {
      fill: "#005ea9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 30s-8.23-7.14-19-.95c-6.08 3.48-10.46 5.53-13.69 6.23A23.7 23.7 0 0 0 10 43.11a22.83 22.83 0 0 0 32.36-4.84 22.27 22.27 0 0 0 1.53-2.42Z",
    style: {
      fill: "#005ea9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.72 30s-8.15-7.08-18.87-.94c-6 3.45-10.36 5.48-13.57 6.18a23.46 23.46 0 0 0 6.66 7.8A22.62 22.62 0 0 0 42 38.26a21.93 21.93 0 0 0 1.52-2.4Z",
    style: {
      fill: "#005da8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.46 30.07s-8.08-7-18.7-.93c-6 3.42-10.27 5.43-13.45 6.12A23.29 23.29 0 0 0 9.91 43a22.42 22.42 0 0 0 31.79-4.76 24.78 24.78 0 0 0 1.5-2.37Z",
    style: {
      fill: "#005da7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2 30.13s-8-6.95-18.53-.92C10.75 32.6 6.49 34.6 3.34 35.28a23.07 23.07 0 0 0 6.54 7.66 22.22 22.22 0 0 0 31.5-4.71 22.6 22.6 0 0 0 1.49-2.35Z",
    style: {
      fill: "#005ca7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.94 30.2s-7.94-6.89-18.37-.92c-5.86 3.36-10.08 5.34-13.2 6a22.9 22.9 0 0 0 6.48 7.6 22 22 0 0 0 31.21-4.67 23.33 23.33 0 0 0 1.48-2.33Z",
    style: {
      fill: "#005ca6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.68 30.26s-7.86-6.83-18.2-.91c-5.81 3.33-10 5.29-13.08 6a22.49 22.49 0 0 0 6.43 7.52 21.81 21.81 0 0 0 30.92-4.62 20.94 20.94 0 0 0 1.46-2.32Z",
    style: {
      fill: "#005ba5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.42 30.32s-7.79-6.76-18-.9c-5.75 3.3-9.9 5.24-12.95 5.9a22.28 22.28 0 0 0 6.33 7.46 21.6 21.6 0 0 0 30.63-4.59 20.48 20.48 0 0 0 1.45-2.29Z",
    style: {
      fill: "#005ba5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.16 30.38s-7.72-6.7-17.86-.89c-5.7 3.27-9.8 5.19-12.83 5.85a22.15 22.15 0 0 0 6.3 7.38 21.4 21.4 0 0 0 30.34-4.54 20.15 20.15 0 0 0 1.44-2.27Z",
    style: {
      fill: "#005aa4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9 30.44s-7.64-6.63-17.69-.88C10.56 32.8 6.5 34.7 3.5 35.35a21.88 21.88 0 0 0 6.24 7.32 21.21 21.21 0 0 0 30.06-4.5 22.3 22.3 0 0 0 1.42-2.25Z",
    style: {
      fill: "#005aa3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.64 30.51s-7.57-6.58-17.52-.88c-5.59 3.21-9.62 5.09-12.59 5.74a21.76 21.76 0 0 0 6.18 7.24 21 21 0 0 0 29.77-4.45 21.93 21.93 0 0 0 1.41-2.23Z",
    style: {
      fill: "#0059a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.38 30.57s-7.5-6.51-17.38-.87c-5.54 3.18-9.53 5-12.47 5.68a21.49 21.49 0 0 0 6.12 7.18 20.79 20.79 0 0 0 29.48-4.41 20 20 0 0 0 1.4-2.21Z",
    style: {
      fill: "#0059a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.12 30.63s-7.42-6.45-17.18-.86c-5.49 3.15-9.44 5-12.35 5.63a21.25 21.25 0 0 0 6.06 7.1 20.59 20.59 0 0 0 29.2-4.37A20 20 0 0 0 40.23 36Z",
    style: {
      fill: "#0058a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.86 30.69s-7.35-6.38-17-.85C10.42 33 6.51 34.79 3.62 35.41a21.2 21.2 0 0 0 6 7 20.39 20.39 0 0 0 28.91-4.33A20.62 20.62 0 0 0 39.9 36Z",
    style: {
      fill: "#0058a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6 30.75a14.77 14.77 0 0 0-16.84-.84c-5.38 3.09-9.25 4.9-12.11 5.52a21 21 0 0 0 5.94 7 20.18 20.18 0 0 0 28.62-4.28A18.77 18.77 0 0 0 39.57 36Z",
    style: {
      fill: "#0057a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.34 30.81A14.62 14.62 0 0 0 15.66 30c-5.32 3.05-9.15 4.85-12 5.46a20.79 20.79 0 0 0 5.88 6.9A20 20 0 0 0 37.9 38.1a22.78 22.78 0 0 0 1.34-2.1Z",
    style: {
      fill: "#00579f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.08 30.88a14.47 14.47 0 0 0-16.51-.83c-5.27 3-9.06 4.8-11.86 5.41a20.57 20.57 0 0 0 5.82 6.82 19.78 19.78 0 0 0 28.05-4.19A21.16 21.16 0 0 0 38.91 36Z",
    style: {
      fill: "#00569f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.82 30.94a14.32 14.32 0 0 0-16.34-.82c-5.21 3-9 4.75-11.74 5.35a20.31 20.31 0 0 0 5.77 6.76 19.57 19.57 0 0 0 27.75-4.16A19 19 0 0 0 38.58 36Z",
    style: {
      fill: "#00569e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.56 31a14.17 14.17 0 0 0-16.17-.8c-5.16 2.95-8.87 4.69-11.62 5.29a20 20 0 0 0 5.71 6.68A19.37 19.37 0 0 0 37 38.06 20.18 20.18 0 0 0 38.25 36Z",
    style: {
      fill: "#00559d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3 31.06a14 14 0 0 0-16-.79c-5.11 2.92-8.78 4.64-11.5 5.23a20 20 0 0 0 5.65 6.62A19.28 19.28 0 0 0 37.92 36Z",
    style: {
      fill: "#00559d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 31.12a13.87 13.87 0 0 0-15.83-.78c-5.05 2.89-8.69 4.59-11.38 5.18a19.67 19.67 0 0 0 5.59 6.54 19 19 0 0 0 26.9-4 19.35 19.35 0 0 0 1.27-2Z",
    style: {
      fill: "#00549c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78 31.19a13.71 13.71 0 0 0-15.66-.78c-5 2.86-8.6 4.54-11.26 5.12A19.52 19.52 0 0 0 9.39 42 18.77 18.77 0 0 0 36 38a22.12 22.12 0 0 0 1.26-2Z",
    style: {
      fill: "#00549b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.52 31.25A13.57 13.57 0 0 0 15 30.48C10.08 33.31 6.52 35 3.89 35.54A19.22 19.22 0 0 0 9.36 42a18.69 18.69 0 0 0 27.57-5.9Z",
    style: {
      fill: "#00539b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.26 31.31a13.41 13.41 0 0 0-15.32-.76c-4.89 2.8-8.42 4.45-11 5a19 19 0 0 0 5.39 6.35 18.37 18.37 0 0 0 26-3.9 21 21 0 0 0 1.23-1.94Z",
    style: {
      fill: "#00539a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 31.37a13.27 13.27 0 0 0-15.15-.75C10 33.39 6.53 35 4 35.57a18.68 18.68 0 0 0 5.3 6.27A18.16 18.16 0 0 0 35.05 38a17.85 17.85 0 0 0 1.22-1.93Z",
    style: {
      fill: "#005299"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.74 31.43a13.13 13.13 0 0 0-15-.74C10 33.43 6.53 35 4 35.59a18.67 18.67 0 0 0 5.28 6.2A18 18 0 0 0 34.73 38a17.51 17.51 0 0 0 1.21-1.91Z",
    style: {
      fill: "#005299"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.48 31.49a13 13 0 0 0-14.82-.73C9.93 33.47 6.53 35.06 4 35.6a18.27 18.27 0 0 0 5.22 6.13A17.77 17.77 0 0 0 34.42 38a18.7 18.7 0 0 0 1.19-1.89Z",
    style: {
      fill: "#005198"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 31.56a12.82 12.82 0 0 0-14.65-.73c-4.67 2.68-8 4.25-10.52 4.79a18.28 18.28 0 0 0 5.16 6.06A17.56 17.56 0 0 0 34.1 38a18.19 18.19 0 0 0 1.18-1.86Z",
    style: {
      fill: "#005197"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 31.62a12.69 12.69 0 0 0-14.48-.72c-4.62 2.65-7.95 4.2-10.4 4.73a17.8 17.8 0 0 0 5.11 6 17.33 17.33 0 0 0 24.59-3.68A17.83 17.83 0 0 0 35 36.1Z",
    style: {
      fill: "#005097"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7 31.68A12.53 12.53 0 0 0 14.39 31c-4.57 2.61-7.85 4.15-10.28 4.68a17.7 17.7 0 0 0 5.05 5.92 17.16 17.16 0 0 0 24.31-3.64 20.56 20.56 0 0 0 1.15-1.82Z",
    style: {
      fill: "#005096"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.44 31.74A12.39 12.39 0 0 0 14.3 31c-4.51 2.58-7.76 4.11-10.16 4.62a17.41 17.41 0 0 0 5 5.85 17 17 0 0 0 25.16-5.39Z",
    style: {
      fill: "#004f96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.18 31.8a12.25 12.25 0 0 0-14-.69c-4.46 2.55-7.67 4.06-10 4.57a17.4 17.4 0 0 0 4.92 5.78 16.75 16.75 0 0 0 23.73-3.55A17.74 17.74 0 0 0 34 36.13Z",
    style: {
      fill: "#004f95"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.92 31.87a12.09 12.09 0 0 0-13.8-.69c-4.41 2.52-7.58 4-9.92 4.51a17.1 17.1 0 0 0 4.87 5.71 16.54 16.54 0 0 0 23.45-3.51 16.1 16.1 0 0 0 1.11-1.75Z",
    style: {
      fill: "#004e94"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.66 31.93A12 12 0 0 0 14 31.25c-4.35 2.49-7.49 4-9.8 4.46A17 17 0 0 0 9 41.35a16.34 16.34 0 0 0 23.2-3.47 18.65 18.65 0 0 0 1.1-1.73Z",
    style: {
      fill: "#004e94"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 32a11.79 11.79 0 0 0-13.46-.67c-4.3 2.46-7.39 3.91-9.68 4.4A16.71 16.71 0 0 0 9 41.29a16.13 16.13 0 0 0 22.87-3.42A18.25 18.25 0 0 0 33 36.16Z",
    style: {
      fill: "#004d93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.14 32.05a11.67 11.67 0 0 0-13.3-.66c-4.24 2.43-7.29 3.86-9.55 4.35A16.51 16.51 0 0 0 9 41.24a16 16 0 0 0 22.59-3.38 17.75 17.75 0 0 0 1.07-1.69Z",
    style: {
      fill: "#004d92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.88 32.11a11.51 11.51 0 0 0-13.13-.65c-4.19 2.4-7.2 3.81-9.43 4.29A16.42 16.42 0 0 0 9 41.18a15.74 15.74 0 0 0 22.3-3.33 18.69 18.69 0 0 0 1.06-1.67Z",
    style: {
      fill: "#004d92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.61 32.18a11.34 11.34 0 0 0-12.95-.65c-4.13 2.37-7.11 3.76-9.31 4.24a16.2 16.2 0 0 0 4.57 5.36 15.53 15.53 0 0 0 22-3.3A16.84 16.84 0 0 0 32 36.19Z",
    style: {
      fill: "#004c91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.35 32.24a11.19 11.19 0 0 0-12.78-.64c-4.08 2.34-7 3.71-9.19 4.18a15.92 15.92 0 0 0 4.51 5.29 15.33 15.33 0 0 0 21.73-3.25 17.61 17.61 0 0 0 1-1.62Z",
    style: {
      fill: "#004c90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.09 32.3a11 11 0 0 0-12.61-.63c-4 2.31-6.92 3.67-9.07 4.13A15.84 15.84 0 0 0 8.87 41a15.13 15.13 0 0 0 21.43-3.19c.37-.52.71-1.06 1-1.6Z",
    style: {
      fill: "#004b90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.83 32.36a10.89 10.89 0 0 0-12.44-.62c-4 2.28-6.83 3.62-8.95 4.07A15.33 15.33 0 0 0 8.84 41 14.91 14.91 0 0 0 30 37.8a16.82 16.82 0 0 0 1-1.58Z",
    style: {
      fill: "#004b8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.57 32.42a10.75 10.75 0 0 0-12.27-.61c-3.92 2.25-6.74 3.57-8.82 4a15.19 15.19 0 0 0 4.33 5.08 14.72 14.72 0 0 0 20.86-3.12q.54-.76 1-1.56Z",
    style: {
      fill: "#004a8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.31 32.48a10.59 10.59 0 0 0-12.1-.6c-3.87 2.22-6.65 3.52-8.7 4a14.89 14.89 0 0 0 4.27 5 14.51 14.51 0 0 0 20.57-3.08 16.66 16.66 0 0 0 1-1.54Z",
    style: {
      fill: "#004a8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.05 32.55A10.44 10.44 0 0 0 13.12 32c-3.81 2.19-6.56 3.47-8.58 3.91a14.78 14.78 0 0 0 4.21 4.89A14.41 14.41 0 0 0 30 36.24Z",
    style: {
      fill: "#00498d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.79 32.61A10.29 10.29 0 0 0 13 32c-3.76 2.16-6.47 3.42-8.46 3.85a14.6 14.6 0 0 0 4.15 4.87 14.11 14.11 0 0 0 20-3 13.9 13.9 0 0 0 .94-1.5Z",
    style: {
      fill: "#00498d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.53 32.67a10.16 10.16 0 0 0-11.6-.58c-3.7 2.12-6.36 3.37-8.33 3.8a14.39 14.39 0 0 0 4.09 4.8 13.9 13.9 0 0 0 19.71-2.95 13.55 13.55 0 0 0 .93-1.48Z",
    style: {
      fill: "#00488c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.27 32.73a10 10 0 0 0-11.43-.57c-3.65 2.09-6.27 3.32-8.21 3.74a14.09 14.09 0 0 0 4 4.73 13.7 13.7 0 0 0 19.42-2.9 14.22 14.22 0 0 0 .95-1.46Z",
    style: {
      fill: "#00488b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32.79a9.87 9.87 0 0 0-11.26-.56c-3.59 2.06-6.18 3.27-8.09 3.69a14 14 0 0 0 4 4.66 13.5 13.5 0 0 0 19.14-2.87 14.27 14.27 0 0 0 .9-1.43Z",
    style: {
      fill: "#00478b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 32.86a9.72 9.72 0 0 0-11.09-.56c-3.54 2-6.09 3.23-8 3.63a13.8 13.8 0 0 0 3.94 4.59 13.33 13.33 0 0 0 19.74-4.23Z",
    style: {
      fill: "#00478a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49 32.92a9.57 9.57 0 0 0-10.92-.55c-3.49 2-6 3.18-7.85 3.58a13.6 13.6 0 0 0 3.85 4.52 13.09 13.09 0 0 0 18.56-2.78A12 12 0 0 0 28 36.3Z",
    style: {
      fill: "#004689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.23 33a9.42 9.42 0 0 0-10.75-.54c-3.43 2-5.9 3.13-7.73 3.52a13.33 13.33 0 0 0 3.8 4.45 12.89 12.89 0 0 0 18.27-2.73 14.2 14.2 0 0 0 .86-1.37Z",
    style: {
      fill: "#004689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 33a9.27 9.27 0 0 0-10.58-.53A30 30 0 0 1 4.78 36a13 13 0 0 0 3.74 4.37 12.74 12.74 0 0 0 18.83-4Z",
    style: {
      fill: "#004588"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.71 33.1a9.13 9.13 0 0 0-10.41-.52A29.35 29.35 0 0 1 4.81 36a12.82 12.82 0 0 0 3.68 4.3 12.47 12.47 0 0 0 17.69-2.65 13.31 13.31 0 0 0 .82-1.32Z",
    style: {
      fill: "#004588"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.45 33.17a9 9 0 0 0-10.24-.51A29.3 29.3 0 0 1 4.84 36a12.8 12.8 0 0 0 3.62 4.23 12.28 12.28 0 0 0 17.41-2.6 12.83 12.83 0 0 0 .82-1.3Z",
    style: {
      fill: "#004487"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.19 33.23a8.81 8.81 0 0 0-10.07-.5A28.68 28.68 0 0 1 4.87 36a12.42 12.42 0 0 0 3.56 4.17 12.08 12.08 0 0 0 17.12-2.56 12.47 12.47 0 0 0 .81-1.28Z",
    style: {
      fill: "#004486"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.93 33.29A8.67 8.67 0 0 0 12 32.8 28.2 28.2 0 0 1 4.9 36a12.29 12.29 0 0 0 3.5 4.09 11.86 11.86 0 0 0 16.83-2.51 12.11 12.11 0 0 0 .8-1.26Z",
    style: {
      fill: "#004386"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.67 33.35a8.53 8.53 0 0 0-9.74-.48 27.58 27.58 0 0 1-7 3.18 12.24 12.24 0 0 0 3.44 4 11.68 11.68 0 0 0 16.55-2.45 11.53 11.53 0 0 0 .78-1.23Z",
    style: {
      fill: "#004385"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.41 33.41a8.37 8.37 0 0 0-9.57-.47A26.93 26.93 0 0 1 5 36.07a11.79 11.79 0 0 0 3.38 4 11.46 11.46 0 0 0 16.22-2.48 11.19 11.19 0 0 0 .77-1.21Z",
    style: {
      fill: "#004284"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.15 33.47a8.24 8.24 0 0 0-9.4-.46A26.43 26.43 0 0 1 5 36.08 11.59 11.59 0 0 0 8.31 40a11.27 11.27 0 0 0 16-2.39 11.89 11.89 0 0 0 .69-1.22Z",
    style: {
      fill: "#004284"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.89 33.54a8.07 8.07 0 0 0-9.23-.46A26.3 26.3 0 0 1 5 36.1a11.47 11.47 0 0 0 3.25 3.81A11.07 11.07 0 0 0 24 37.57a12.07 12.07 0 0 0 .74-1.17Z",
    style: {
      fill: "#004283"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.63 33.6a7.93 7.93 0 0 0-9.06-.45 25.73 25.73 0 0 1-6.51 3 11.18 11.18 0 0 0 3.19 3.75 10.87 10.87 0 0 0 15.4-2.3 11.83 11.83 0 0 0 .73-1.16Z",
    style: {
      fill: "#004182"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.37 33.66a7.77 7.77 0 0 0-8.89-.44 25.6 25.6 0 0 1-6.39 2.91 11 11 0 0 0 3.13 3.67 10.65 10.65 0 0 0 15.11-2.26 9 9 0 0 0 .72-1.13Z",
    style: {
      fill: "#004182"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.11 33.72a7.64 7.64 0 0 0-8.72-.43 25 25 0 0 1-6.27 2.85 10.71 10.71 0 0 0 3.08 3.61A10.45 10.45 0 0 0 23 37.53a10.85 10.85 0 0 0 .7-1.11Z",
    style: {
      fill: "#004081"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.85 33.78a7.5 7.5 0 0 0-8.55-.42 24.68 24.68 0 0 1-6.15 2.8 10.47 10.47 0 0 0 3 3.53 10.25 10.25 0 0 0 14.55-2.17 9.53 9.53 0 0 0 .69-1.09Z",
    style: {
      fill: "#004080"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.59 33.85a7.34 7.34 0 0 0-8.39-.42 23.87 23.87 0 0 1-6 2.74 10.32 10.32 0 0 0 3 3.47 10.1 10.1 0 0 0 14.92-3.2Z",
    style: {
      fill: "#003f80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.33 33.91a7.21 7.21 0 0 0-8.22-.41 23.74 23.74 0 0 1-5.9 2.69 10.18 10.18 0 0 0 2.9 3.39 9.85 9.85 0 0 0 14-2.08 11.53 11.53 0 0 0 .66-1Z",
    style: {
      fill: "#003f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07 34a7.05 7.05 0 0 0-8-.4 22.6 22.6 0 0 1-5.83 2.6 9.91 9.91 0 0 0 2.84 3.33 9.65 9.65 0 0 0 13.67-2.05 9.23 9.23 0 0 0 .65-1Z",
    style: {
      fill: "#003e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.81 34a6.91 6.91 0 0 0-7.88-.39 22.3 22.3 0 0 1-5.66 2.58 9.79 9.79 0 0 0 2.78 3.25 9.43 9.43 0 0 0 13.38-2 8.89 8.89 0 0 0 .64-1Z",
    style: {
      fill: "#003e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.55 34.09a6.75 6.75 0 0 0-7.71-.38 21.68 21.68 0 0 1-5.54 2.52A9.5 9.5 0 0 0 8 39.42a9.25 9.25 0 0 0 13.1-2 10.08 10.08 0 0 0 .62-1Z",
    style: {
      fill: "#003d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29 34.16a6.61 6.61 0 0 0-7.54-.38 21.54 21.54 0 0 1-5.42 2.47A9.29 9.29 0 0 0 8 39.36a9 9 0 0 0 12.8-1.91 8.16 8.16 0 0 0 .61-1Z",
    style: {
      fill: "#003d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 34.22a6.45 6.45 0 0 0-7.37-.37 20.77 20.77 0 0 1-5.3 2.41A9.33 9.33 0 0 0 8 39.31a8.83 8.83 0 0 0 12.52-1.87 10.61 10.61 0 0 0 .6-.94Z",
    style: {
      fill: "#003d7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.77 34.28a6.31 6.31 0 0 0-7.2-.36 20.48 20.48 0 0 1-5.18 2.36 8.88 8.88 0 0 0 2.54 3 8.63 8.63 0 0 0 12.24-1.83 10.77 10.77 0 0 0 .58-.91Z",
    style: {
      fill: "#003c7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.51 34.34a6.15 6.15 0 0 0-7-.35 19.85 19.85 0 0 1-5.06 2.3A8.82 8.82 0 0 0 7.9 39.2a8.42 8.42 0 0 0 12-1.79 9.53 9.53 0 0 0 .57-.89Z",
    style: {
      fill: "#003c7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 34.4a6 6 0 0 0-6.86-.34 19.56 19.56 0 0 1-4.94 2.25 8.52 8.52 0 0 0 2.43 2.83 8.21 8.21 0 0 0 11.65-1.74 8 8 0 0 0 .56-.87Z",
    style: {
      fill: "#003b7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 34.46a5.87 5.87 0 0 0-6.7-.33 18.41 18.41 0 0 1-4.81 2.19 8.24 8.24 0 0 0 2.37 2.77 8 8 0 0 0 11.37-1.7 8.65 8.65 0 0 0 .54-.85Z",
    style: {
      fill: "#003b7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.73 34.53a5.72 5.72 0 0 0-6.53-.33 18.75 18.75 0 0 1-4.68 2.14A8 8 0 0 0 7.82 39a7.82 7.82 0 0 0 11.08-1.62 8.28 8.28 0 0 0 .53-.83Z",
    style: {
      fill: "#003a79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.47 34.59a5.57 5.57 0 0 0-6.36-.32 18 18 0 0 1-4.56 2.08A7.91 7.91 0 0 0 7.79 39a7.61 7.61 0 0 0 10.79-1.62c.19-.26.36-.53.52-.8Z",
    style: {
      fill: "#003a78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49 33.78c0 1 0 2.29 1.45 2.29 1.2 0 1.51-.57 1.51-2.29v-4h5.25v2.75c0 6.35-2.34 8.17-6.76 8.17-3.79 0-6.7-2.08-6.7-8.43V19.9c0-6.35 2.91-8.43 6.7-8.43 4.42 0 6.76 1.82 6.76 8.17v2.23h-5.25v-3.43c0-1.72-.31-2.29-1.51-2.29-1.4 0-1.45 1.25-1.45 2.29ZM180.28 17.92v22.41H175V2.11h5.25v12.17c.42-.26 2.45-2.81 4.27-2.81 2.8 0 3.95 3.23 3.95 5.57v23.29h-5.25V17.82c0-1.1-.63-1.25-1.25-1.25-.97 0-1.69 1.35-1.69 1.35ZM205.71 30.14v3.28s0 7.33-6.81 7.33-6.76-7.49-6.76-7.49V19s.05-7.49 6.81-7.49 6.76 7.33 6.76 7.33v8.27H197v6.19s0 2.86 1.92 2.86 1.87-2.86 1.87-2.86v-3.16ZM197 23h3.79v-4s.11-2.91-1.87-2.91S197 19 197 19ZM214.13 33.78c0 1 .05 2.29 1.46 2.29 1.2 0 1.51-.57 1.51-2.29v-4h5.25v2.75c0 6.35-2.34 8.17-6.76 8.17-3.8 0-6.71-2.08-6.71-8.43V19.9c0-6.35 2.91-8.43 6.71-8.43 4.42 0 6.76 1.82 6.76 8.17v2.23h-5.25v-3.43c0-1.72-.31-2.29-1.51-2.29-1.41 0-1.46 1.25-1.46 2.29ZM230.93 2.11v18.15h.26l.31-.94 2.55-7.43h4.73L235 21.14l4.78 19.19h-5.05l-2.6-11.49-.1-.42h-.26l-.16.42-.67 1.66v9.83h-5.25V2.11ZM157.21 49h6.06l1.87-5.76L167 49h6.06l-4.9 3.57 1.87 5.77-4.91-3.57-4.9 3.57 1.87-5.77ZM174 49h6.06l1.94-5.76 1.82 5.76h6.06L185 52.57l1.87 5.77-4.87-3.57-5 3.57 1.87-5.77ZM190.81 49h6.06l1.87-5.76 1.88 5.76h6.06l-4.9 3.57 1.87 5.77-4.91-3.57-4.91 3.57 1.88-5.77ZM207.61 49h6.06l1.87-5.76 1.88 5.76h6.06l-4.9 3.57 1.87 5.77-4.91-3.57-4.91 3.57 1.88-5.77ZM224.41 49h6.06l1.87-5.76 1.87 5.76h6.06l-4.89 3.57 1.87 5.77-4.91-3.57-4.91 3.57 1.88-5.77Z",
    style: {
      fill: "#fbba00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.43 57.28a1.63 1.63 0 0 1-.13-.75v-.21a1.93 1.93 0 0 1-1.68 1.12c-1 0-1.68-.83-1.68-2.2a2.6 2.6 0 0 1 1.33-2.42 4.13 4.13 0 0 1 1.91-.43c0-1.38-.12-1.67-.55-1.67S56 51 56 51.89l-1.81-.21a2.41 2.41 0 0 1 2.53-2.45 2.45 2.45 0 0 1 2.11 1 4.18 4.18 0 0 1 .33 2.2v3.18a5.43 5.43 0 0 0 .1 1.71Zm-.25-3.81c-.85.15-1.19.6-1.19 1.56 0 .67.16 1 .51 1a.6.6 0 0 0 .56-.48 6.91 6.91 0 0 0 .12-1.68ZM61 47l1.78-.15v2.56H64V51h-1.22v3.33c0 1 .14 1.23.81 1.23a3 3 0 0 0 .51 0v1.63a4.47 4.47 0 0 1-1.31.21 2.09 2.09 0 0 1-1.62-.63c-.35-.43-.43-.88-.43-2.34V51h-.85v-1.61h.94ZM67.54 46.61h2v3.81a1.53 1.53 0 0 1 1.6-1.19 1.62 1.62 0 0 1 1.43.66 3.2 3.2 0 0 1 .3 1.68v5.71h-2v-5.47c0-.69-.13-.88-.62-.88s-.66.22-.66 1v5.39h-2ZM79.42 53.33c0 2.72-1 4.11-2.84 4.11a2.33 2.33 0 0 1-1.84-.73 5.32 5.32 0 0 1-.94-3.4c0-2.65 1-4.08 2.86-4.08s2.76 1.46 2.76 4.1ZM75.93 53c0 2.59.09 3 .67 3s.69-.41.69-2.73c0-2.13-.11-2.6-.64-2.6s-.72.39-.72 2.33ZM80.36 49.39h1.84v1.17c.37-1 .8-1.33 1.63-1.33s1.28.32 1.63 1.25c.29-.89.73-1.25 1.54-1.25a1.61 1.61 0 0 1 1.51.77 4.21 4.21 0 0 1 .24 1.73v5.55h-2v-5.55c0-.61-.15-.8-.6-.8s-.61.26-.61 1.17v5.18h-2v-5.42c0-.74-.11-.93-.57-.93s-.61.26-.61 1v5.33h-2ZM91.66 53.7v.3c0 1.37.24 1.89.86 1.89s.7-.32.83-1.3l1.7.14a3.19 3.19 0 0 1-.8 2 2.39 2.39 0 0 1-1.81.68q-2.84 0-2.83-4c0-2.7 1-4.18 2.81-4.18a2.41 2.41 0 0 1 2.42 1.84 8.58 8.58 0 0 1 .27 2.63Zm1.55-1.3c0-1.21-.23-1.73-.74-1.73s-.77.47-.83 1.73ZM104.09 53.33c0 2.72-1 4.11-2.83 4.11a2.3 2.3 0 0 1-1.84-.73 5.32 5.32 0 0 1-1-3.4c0-2.65 1-4.08 2.87-4.08s2.8 1.46 2.8 4.1ZM100.6 53c0 2.59.1 3 .67 3s.69-.41.69-2.73c0-2.13-.11-2.6-.64-2.6s-.72.39-.72 2.33ZM105 49.39h1.84v1.16c.4-1 .88-1.32 1.76-1.32a1.67 1.67 0 0 1 1.46.64 3.32 3.32 0 0 1 .32 1.89v5.52h-2v-5.36a2.42 2.42 0 0 0-.06-.7.6.6 0 0 0-.56-.29c-.48 0-.66.27-.66 1v5.36h-2ZM116.92 57.28a1.51 1.51 0 0 1-.13-.75v-.21a1.93 1.93 0 0 1-1.68 1.12c-1 0-1.68-.83-1.68-2.2a2.58 2.58 0 0 1 1.33-2.42 4.08 4.08 0 0 1 1.9-.43c0-1.38-.11-1.67-.54-1.67s-.59.32-.66 1.17l-1.81-.21a2.42 2.42 0 0 1 2.53-2.45 2.45 2.45 0 0 1 2.12 1 4.18 4.18 0 0 1 .33 2.2v3.18a5.43 5.43 0 0 0 .1 1.71Zm-.26-3.81c-.85.15-1.18.6-1.18 1.56 0 .67.16 1 .51 1a.6.6 0 0 0 .56-.48 7.12 7.12 0 0 0 .11-1.68ZM119.8 46.61h2v10.67h-2ZM123.06 46.61h2v10.67h-2ZM131.72 51.65c-.1-.61-.37-.9-.88-.9s-.66.21-.66.55a.75.75 0 0 0 .42.64 8.84 8.84 0 0 0 1.29.64 2.57 2.57 0 1 1-3.72 2.53l1.58-.26c.11.72.43 1 1 1s.79-.24.79-.61a.77.77 0 0 0-.37-.67 7 7 0 0 0-1-.5c-1.43-.69-1.91-1.3-1.91-2.39a2.42 2.42 0 0 1 2.55-2.48c1.24 0 2 .63 2.3 2.05ZM136 53.7v.3c0 1.37.24 1.89.86 1.89s.71-.32.83-1.3l1.7.14a3.09 3.09 0 0 1-.8 2 2.39 2.39 0 0 1-1.81.68q-2.83 0-2.83-4c0-2.7 1-4.18 2.82-4.18a2.4 2.4 0 0 1 2.41 1.84 8.2 8.2 0 0 1 .28 2.63Zm1.55-1.3c0-1.21-.22-1.73-.74-1.73s-.76.47-.83 1.73ZM143.4 57.28a1.51 1.51 0 0 1-.13-.75v-.21a1.93 1.93 0 0 1-1.68 1.12c-1 0-1.68-.83-1.68-2.2a2.58 2.58 0 0 1 1.33-2.42 4.08 4.08 0 0 1 1.9-.43c0-1.38-.11-1.67-.54-1.67s-.59.32-.66 1.17l-1.81-.21a2.42 2.42 0 0 1 2.53-2.45 2.45 2.45 0 0 1 2.12 1 4.18 4.18 0 0 1 .33 2.2v3.18a5.43 5.43 0 0 0 .1 1.71Zm-.26-3.81c-.85.15-1.18.6-1.18 1.56 0 .67.16 1 .51 1a.6.6 0 0 0 .56-.48 7.12 7.12 0 0 0 .11-1.68ZM149.45 51.65c-.1-.61-.37-.9-.88-.9s-.66.21-.66.55a.75.75 0 0 0 .42.64 8.84 8.84 0 0 0 1.29.64 2.57 2.57 0 1 1-3.73 2.53l1.59-.26c.11.72.43 1 1 1s.78-.24.78-.61a.77.77 0 0 0-.37-.67 5.78 5.78 0 0 0-1-.5c-1.42-.69-1.9-1.3-1.9-2.39a2.42 2.42 0 0 1 2.54-2.48c1.25 0 2 .63 2.31 2.05Z",
    style: {
      fill: "#fff"
    }
  }))));
};

export default SvgLogoInverted;